import styled from "styled-components";

const LogsPageStyled = styled.div`

`;

export default LogsPageStyled;